module.exports = __webpack_public_path__ + "img/nextdoor-how-to-tag.a26b9c40.png";